import { CheckCircleFilled, ClockCircleFilled, PauseCircleFilled } from '@ant-design/icons'
import { Flex, Space, theme, Typography } from 'antd'
import dayjs from 'dayjs'
import { FC } from 'react'
import { outputDateFormat } from '../../../../../constants/constants'
import { OrderStatus } from '../../../../../types/api/form-order'

interface LastOrderCellProps {
    status?: OrderStatus
    estimatedDate?: string
}

const LastOrderCell: FC<LastOrderCellProps> = ({ status, estimatedDate }) => {
    const { token } = theme.useToken()

    if (!status) return <>—</>

    const getIconByStatus = (orderStatus: OrderStatus) => {
        switch (orderStatus) {
            case 'Создан':
                return <PauseCircleFilled style={{ color: token.yellow5 }} />
            case 'В пути':
            case 'В сборке':
                return <ClockCircleFilled style={{ color: token.blue5 }} />
            case 'Готов к выдаче':
            case 'Завершен':
                return <CheckCircleFilled style={{ color: token.green5 }} />
        }
    }

    const dateColor = status === 'Завершен' ? token.colorSuccess : token.colorInfo
    const formattedDate = estimatedDate ? dayjs(estimatedDate).format(outputDateFormat) : null

    return (
        <Flex align='center' gap={4}>
            <Space size={4}>
                {getIconByStatus(status)}
                <Typography.Text>{status}</Typography.Text>
            </Space>
            {formattedDate && (
                <Typography.Text style={{ color: dateColor, fontSize: 12 }}>
                    {formattedDate}
                </Typography.Text>
            )}
        </Flex>
    )
}

export default LastOrderCell
